import gql from "graphql-tag";

export const UPDATE_VENDOR_PROFILE = gql`
  mutation UpdateVendorProfile($entityId: String!, $fieldsObj: UpdateVendorProfileInput!) {
    updateVendorProfile(entityId: $entityId, fieldsObj: $fieldsObj) {
      id
    }
  }
`;
